import CategorySection from '../CategorySection';
import DishCard from '../DishCard';

export default function SwiggyCardsLayout({ 
  filtered, 
  categories, 
  bestSellers, 
  sponsoredItems, 
  cart, 
  onUpdateQuantity,
  search
}) {
    return (
        <div className="layout-swiggy-cards">
            {/* ⚡ Quick Picks — Best Sellers */}
            {!search && bestSellers.length > 0 && (
                <section className="mb-6">
                    <h2 className="text-base font-black text-charcoal mb-3 flex items-center gap-2">
                        ⚡ Best Sellers
                        <span className="w-8 h-0.5 bg-primary rounded-full" />
                    </h2>
                    <div className="flex overflow-x-auto gap-3 pb-2 no-scrollbar -mx-4 px-4">
                        {bestSellers.map(dish => {
                            const qty = cart[dish.id] || 0;
                            return (
                                <div key={dish.id} className="flex-none w-[170px] md:w-[200px]">
                                    <DishCard 
                                        dish={dish} 
                                        layout="grid"
                                        quantity={qty} 
                                        onUpdateQuantity={(q, e) => onUpdateQuantity(dish.id, q, e, dish)} 
                                    />
                                </div>
                            );
                        })}
                    </div>
                </section>
            )}

            {/* ⭐ Chef's Picks — Sponsored */}
            {!search && sponsoredItems.length > 0 && (
                <section className="mb-6">
                    <h2 className="text-base font-black text-charcoal mb-3 flex items-center gap-2">
                        ⭐ Chef's Picks
                        <span className="w-8 h-0.5 bg-primary rounded-full" />
                    </h2>
                    <div className="flex overflow-x-auto gap-3 pb-2 no-scrollbar -mx-4 px-4">
                        {sponsoredItems.map(dish => {
                            const qty = cart[dish.id] || 0;
                            return (
                                <div key={dish.id} className="flex-none w-[170px] md:w-[200px]">
                                    <DishCard 
                                        dish={dish} 
                                        layout="grid"
                                        quantity={qty} 
                                        onUpdateQuantity={(q, e) => onUpdateQuantity(dish.id, q, e, dish)} 
                                    />
                                </div>
                            );
                        })}
                    </div>
                </section>
            )}

            {/* ─── Full Menu by Category ─── */}
            {categories.filter(cat => cat !== 'All').map(cat => {
                const catDishes = filtered.filter(d => d.category === cat);
                if (catDishes.length === 0) return null;
                return (
                    <section key={cat} id={`cat-${cat}`} className="mb-8 pt-2">
                        <h2 className="text-base font-black text-charcoal mb-3 flex items-center gap-2">
                            {cat}
                            <span className="w-8 h-0.5 bg-primary rounded-full" />
                            <span className="text-[11px] font-bold text-slate-400 ml-auto">
                                {catDishes.length} items
                            </span>
                        </h2>
                        <div className="space-y-3">
                            <CategorySection
                                id={`cat-${cat}`}
                                title={cat}
                                dishes={catDishes}
                                cart={cart}
                                onUpdateQuantity={onUpdateQuantity}
                            />
                        </div>
                    </section>
                );
            })}
        </div>
    );
}
